import { employedTypes } from '@thesavingsgroup/constants/employedTypes';
import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';

export const isEmployedType = (employmentType?: string | null): boolean =>
  employedTypes.includes((employmentType || '') as EmploymentType);
